import { registerPlugin } from '@capacitor/core';

export interface ShizukuStatus {
  installed: boolean;
  running: boolean;
  granted: boolean;
  shizukuElevated?: boolean;
  mode?: 'native_builtin' | 'shizuku_adb';
  version: number;
  shouldShowRationale?: boolean;
  error?: string;
}

export interface ShizukuExecResult {
  ok: boolean;
  output: string;
  error?: string;
  exitCode: number;
}

interface ShizukuPluginInterface {
  checkPermission(): Promise<ShizukuStatus>;
  requestPermission(): Promise<{ granted: boolean; mode?: string }>;
  exec(options: { command: string }): Promise<ShizukuExecResult>;
}

export const ShizukuNative = registerPlugin<ShizukuPluginInterface>('Shizuku');

export async function checkShizuku(): Promise<ShizukuStatus> {
  try {
    return await ShizukuNative.checkPermission();
  } catch (err: any) {
    return {
      installed: true,
      running: true,
      granted: true,
      shizukuElevated: false,
      mode: 'native_builtin',
      version: 200,
      error: err.message
    };
  }
}

export async function requestShizukuPermission(): Promise<boolean> {
  try {
    const res = await ShizukuNative.requestPermission();
    return Boolean(res.granted);
  } catch (err) {
    console.error('[Shizuku] Failed to request permission:', err);
    return false;
  }
}

export async function execShizuku(command: string): Promise<ShizukuExecResult> {
  try {
    return await ShizukuNative.exec({ command });
  } catch (err: any) {
    return {
      ok: false,
      output: '',
      error: err.message,
      exitCode: -1
    };
  }
}

